import { useLanguage } from '../context/LanguageContext';
import { AlertCircle, RefreshCcw, Heart } from 'lucide-react';

const PainSection = () => {
  const { t } = useLanguage();

  const painItems = [
    { key: 'pain_item1', icon: AlertCircle },
    { key: 'pain_item2', icon: RefreshCcw },
    { key: 'pain_item3', icon: Heart },
  ];

  return (
    <section 
      className="py-20 md:py-28"
      style={{ backgroundColor: 'var(--warm-white)' }}
      data-testid="pain-section"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Section Title */}
        <h2 
          className="text-3xl md:text-4xl text-center mb-12 md:mb-16"
          style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
        >
          {t('pain_title')}
        </h2>

        {/* Pain Points */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-12">
          {painItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={item.key}
                className="card-organic p-6 md:p-8 text-center animate-fade-in"
                style={{ animationDelay: `${index * 150}ms` }}
                data-testid={`pain-item-${index}`}
              >
                <div 
                  className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4"
                  style={{ backgroundColor: 'var(--sage-100)' }}
                >
                  <Icon size={24} style={{ color: 'var(--sage-600)' }} />
                </div>
                <p className="text-gray-700 leading-relaxed">
                  {t(item.key)}
                </p>
              </div>
            );
          })}
        </div>

        {/* Quote */}
        <div 
          className="max-w-3xl mx-auto text-center p-8 md:p-12 rounded-3xl"
          style={{ backgroundColor: 'var(--sand-50)' }}
        >
          <p className="text-base md:text-lg text-gray-700 leading-relaxed">
            {t('pain_quote')} {t('pain_insight')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default PainSection;
